import React from 'react'
import ProductDetailActiveAndEditBar from '../../../components/store/products/ProductDetailActiveAndEditBar'
import ProductCard from '../../../components/store/products/ProductCard'
import ProductVariantList from '../../../components/store/products/variants/ProductVariantList'
import ProductExtraItemList from '../../../components/store/products/extraItems/ProductExtraItemList'
import ProductSpecialChangesList from '../../../components/store/products/specialChanges/ProductSpecialChangesList'
import { Link, useParams } from 'react-router-dom'
import { useSingleProductDetail } from '../../../hooks/store/product'
import LoadingErrorState from '../../../components/ui/LoadingErrorState'
import { useTranslation } from 'react-i18next'
import { PermissionGate } from '../../../components/admin/PermissionGate'
import { PermissionsKey } from '../../../data/permissions'
import {  CornerUpLeft } from 'lucide-react'
import BackLink from '../../../components/ui/BackLink'

export default function ProductDetailsPage() {
   const { productId,storeId} = useParams<{ productId: string,storeId:string}>();
  const numericStoreId = storeId ? parseInt(storeId) : undefined;
   const numericProductId = productId ? parseInt(productId) : 0;

   const {data:product, isLoading, isError} = useSingleProductDetail(numericProductId,numericStoreId);
   const {i18n,t} = useTranslation();
    

  return (
    <div className=' container lg:p-6 h-[100vh] overflow-auto'>
        <LoadingErrorState
        isError={isError}
        isLoading={isLoading}
        />
        {
          product&&
          <>
          <div className='flex items-center justify-between'>
            <BackLink path={numericStoreId?`/admin/stores/${numericStoreId}/products`:`/store/products`}/>
            <PermissionGate permissions={[PermissionsKey.UpdateProduct]}>
              <ProductDetailActiveAndEditBar active={product.isActive} productId={product.id} storeId={numericStoreId}/>
            </PermissionGate>
          </div>
          <div className=' max-w-[800px] mt-8'>
            <ProductCard
            id={product.id}
            name={product.languages.find(ln=>ln.languageCode===i18n.language)?.name||""}
            catgeory={product.category.languages[0].title}
            prepTime={product.preparationTime}
            productNum={product.productNumber}
            longDescription={product.languages.find(ln=>ln.languageCode===i18n.language)?.longDescription||""}
            shortDescrption={product.languages.find(ln=>ln.languageCode===i18n.language)?.shortDescription||""}
            images={product.images||[]}
            price={product.basePrice}
            />
            </div>
            <div className=' mt-12 ps-5 grid lg:grid-cols-2 xl:grid-cols-3 gap-20'>
                <ProductVariantList variants={product.variantCategories} storeId={numericStoreId}/>
                <ProductExtraItemList extraItems={product.extras} storeId={numericStoreId}/>
                <ProductSpecialChangesList specialChanges={product.instructions} storeId={numericStoreId}/>
            </div>
          </>
        }
    </div>
  )
}
